import { ApplicationCategory } from '../../Applications/ApplicationsList/ApplicationsList.types';
import { Bounty } from './BountyList.types';

const dummyBounty: Bounty = {
  id: 'dummy-bounty',
  name: 'DeFi yield optimizer',
  description:
    'Create tools, dashboards, or optimizations that make running Beam nodes simpler and more reliable.',
  category: ApplicationCategory.TECH,
  reward: 'Up to $40,000',
  whatWeWant: `
We’re looking for developers to build a yield optimization protocol on Beam, designed to attract liquidity, drive transactions, and showcase the power of Beam’s EVM compatibility

Your solution should:
- Aggregate yield opportunities or auto-compound across Beam-based protocols.
- Directly integrate with the $BEAM token (e.g. staking rewards or fee rebates).
- Be built for future extensibility with Beam SDK tools.
`,
  whyThisMatters:
    'A strong DeFi landscape is essential for Beam. By making it easy for users to earn better returns, we bring in more liquidity, more transactions, and more developers eager to build on top.',
  whatWeExpect: `
- Aggregate yield opportunities or auto-compound across Beam-based protocols.
- Directly integrate with the $BEAM token (e.g. staking rewards or fee rebates).
- Be built for future extensibility with Beam SDK tools.
`,
  whoCanApply:
    'Anyone — solo developers, small teams, or existing DeFi projects wanting to expand to Beam. We’ll prioritize applicants with a track record of secure smart contracts or audited deployments.',
  whatYouGet: `
- Up to $50,000 USD in milestone-based payouts.
- Full technical support from Beam Foundation engineers.
- Ecosystem exposure and co-marketing.
`,
  applicationsCount: 2,
};

export const bounties: Bounty[] = [
  dummyBounty,
  { ...dummyBounty, id: 'dummy-bounty-2', category: ApplicationCategory.AI },
  { ...dummyBounty, id: 'dummy-bounty-3', category: ApplicationCategory.OTHER },
  { ...dummyBounty, id: 'dummy-bounty-4', category: ApplicationCategory.DEFI },
  { ...dummyBounty, id: 'dummy-bounty-5', category: ApplicationCategory.NFT },
  {
    ...dummyBounty,
    id: 'dummy-bounty-6',
    category: ApplicationCategory.RESEARCH,
  },
  {
    ...dummyBounty,
    id: 'dummy-bounty-7',
    category: ApplicationCategory.COMMUNITY,
  },
];
